import { render, staticRenderFns } from "./Reducao.vue?vue&type=template&id=5c24e33a&"
import script from "./Reducao.vue?vue&type=script&lang=js&"
export * from "./Reducao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports